<template>
  <tippy
    ref="tippyRef"
    interactive
    trigger="click"
    theme="light"
    placement="top"
    :arrow="false"
    :offset="[5, 0]"
    class="flex grow"
  >
    <template #trigger>
      <button type="button" class="text-link flex items-center pt-2 text-sm font-medium">
        <info-icon class="icon-m mr-1" />
        {{ $t('pins.modal.how_pins_work') }}
      </button>
    </template>

    <div class="text-gray-80 px-5 pb-4 pt-6 text-left text-xs">
      <div class="mb-5 flex justify-between">
        <div class="text-base font-medium">{{ $t('pins.modal.pins_for_coaching') }}</div>
        <button type="button" class="group" @click="tippyRef?.tip.hide()">
          <x-icon class="icon-m group-hover:text-gray-60 text-gray-50" />
        </button>
      </div>

      <div class="mb-4 flex gap-3">
        <folder-icon class="icon-m mt-0.5 shrink-0 text-gray-50" />
        {{ $t('pins.modal.how_to_save_pins') }}
      </div>
      <a :href="$t('support_links.pins_for_coaching')" class="content-link" rel="noopener noreferrer" target="_blank">
        {{ $t('universal.read_more') }}
      </a>
    </div>
  </tippy>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { InfoIcon, XIcon, FolderIcon } from '@klausapp/ui-kit/icons'
import type { Instance } from 'tippy.js'

import { Tippy } from '@/components/Tippy'

const tippyRef = ref<{ tip: Instance } | null>(null)
</script>
